export default "__VITE_ASSET__bPxs7QBs__"